import React from 'react';

interface DroneLogoMarkProps {
  className?: string;
  style?: React.CSSProperties;
  animated?: boolean;
}

const DroneLogoMark: React.FC<DroneLogoMarkProps> = ({ className, style }) => (
  <img
    src="/debtdrone-logo.svg"
    alt="DebtDrone"
    aria-label="DebtDrone"
    className={className}
    style={style}
  />
);

export default DroneLogoMark;
